module.exports = __webpack_public_path__ + "img/01.67cf8c5a.jpg";